import React from 'react';
import { FormattedMessage } from 'react-intl';

import { EXPORT_REQUEST_STATUS } from '../../../queries/queryExportRequests';

export const STATUS_LABEL = {
  [EXPORT_REQUEST_STATUS.COMPLETED]: <FormattedMessage id="downloadCenter.status.completed" defaultMessage="Listo" />,
  [EXPORT_REQUEST_STATUS.PROCESSING]: <FormattedMessage id="downloadCenter.status.processing" defaultMessage="Procesando" />,
  [EXPORT_REQUEST_STATUS.FAILED]: <FormattedMessage id="downloadCenter.status.failed" defaultMessage="Error" />,
  [EXPORT_REQUEST_STATUS.EXPIRED]: <FormattedMessage id="downloadCenter.status.expired" defaultMessage="Expirado" />
};

export const readExportRequests = response => {
  if (Array.isArray(response)) return response;

  return (response || {}).data || [];
};

export const canDownload = exportRequest => exportRequest.status === EXPORT_REQUEST_STATUS.COMPLETED && !!exportRequest.downloadAvailable;
